import React from "react";
import { LIMIT_PERIOD_I18N_KEYS, LIMIT_PERIOD_ORDER } from "../../constants";
import { ToggleButton, ToggleWrapper } from "./elements";

const LimitsPeriodToggle = ({ value, onChange, translate, disabled = false }) => (
	<ToggleWrapper>
		{LIMIT_PERIOD_ORDER.map((period) => (
			<ToggleButton
				key={period}
				type="button"
				$active={value === period}
				disabled={disabled}
				onClick={() => onChange(period)}>
				{translate(LIMIT_PERIOD_I18N_KEYS[period])}
			</ToggleButton>
		))}
	</ToggleWrapper>
);

export default LimitsPeriodToggle;
